import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import 'hammerjs';

import { RuntimeConfigService } from './app/services/runtime-config.service';

const configService = new RuntimeConfigService();
configService.initializeConfig().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));